import { Button, HStack, Text } from "@chakra-ui/react";
import useTranslate from "@raiden/library/hooks/useTranslate";
import { Href } from "../../../../../components/Href";
import { Icon } from "../../../../../components/Icon";
import {
  getMenuItemAdapterType,
  getMenuItemAdapterValues,
} from "../../../../../helpers/menus/getMenuItemAdapterValues";

/**
 * @typedef {Object} Props
 * @property {import("@raiden/library/types/Configuration").ConfigurationMenuItem} menuItem
 */
/**
 * @param {Props & import("@chakra-ui/react").BoxProps} props
 */
export function MenuItem({ menuItem, ...otherProps }) {
  const type = getMenuItemAdapterType({ menuItem });

  const translate = useTranslate();

  if (type === undefined) {
    return null;
  }

  const { title, href, target } = getMenuItemAdapterValues({
    menuItem,
    translate,
  });

  if (!href) {
    return null;
  }

  return (
    <Href href={href} target={target} {...otherProps}>
      <Button
        as="div"
        backgroundColor="brandPrimary.500"
        colorScheme="brandPrimary"
        borderRadius="12px"
        h="2rem"
        w="full"
        pr=".3rem">
        <HStack justifyContent="space-between" w="full" h="100%">
          <Text as="span" color="inherit">
            {title}
          </Text>

          <Icon icon="ms_chevron_right" size="24px" color="inherit" />
        </HStack>
      </Button>
    </Href>
  );
}
